import { Link } from 'gatsby';
import React from 'react';
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet,
  PoweredBy,
} from 'react-instantsearch-dom';

const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits;
  return hitCount > 0 ? (
    <div className="HitCount">
      {hitCount} resultat{hitCount !== 1 ? 'er' : ''}
    </div>
  ) : null;
});

const PageHit = ({ hit }) => {
  const dirs = hit.slug.slice(1, -1).split('/');

  return (
    <>
      <h3>
        <Link to={hit.slug}>
          <Highlight attribute="title" hit={hit} tagName="mark" />
        </Link>
      </h3>
      <ul className="breadcrumbs">
        <li><Link to="/">sollerodgolf.dk</Link></li>
        {dirs.map((dir, index, array) => ((index === 0)
          ? <li><span>{dir}</span></li>
          : <li><Link to={index === 0 ? '' : `/${array.slice(0, index + 1).join('/')}/`}>{dir}</Link></li>))}
      </ul>
      <Snippet attribute="excerpt" hit={hit} tagName="mark" />
    </>
  );
};

const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    <HitCount />
    <Hits className="Hits" hitComponent={PageHit} />
  </Index>
);

export const SearchResults = ({ indices, className }) => (
  <div className={className}>
    {indices.map((index) => (
      <HitsInIndex index={index} key={index.name} />
    ))}
    <PoweredBy />
  </div>
);
